import { connect } from 'react-redux';
import CookieConsent from '../components/CookieConsent';

import {
  getCookiesData,
  saveCookies,
} from 'apps/cookieConsent/actions/cookies';

export default connect(
  (state) => ({
    shouldLoadOneTrust: state.user.betaFeatures.includes('ONE_TRUST_COOKIES'),
  }),
  {
    getCookiesData,
    saveCookies,
  },
)(CookieConsent);
